export enum APP_ENV {
  Pro = 'pro',
  Dev = 'dev',
  Staging = 'staging',
  Local = 'local',
  Test = 'test',
}

const CURRENT_ENV: string = process.env.NEXT_PUBLIC_APP_CURRENT_ENV as string;

export function isProduction() {
  return CURRENT_ENV === APP_ENV.Pro;
}

export function unProduction() {
  return CURRENT_ENV !== APP_ENV.Pro;
}

export function isDev() {
  return CURRENT_ENV === APP_ENV.Dev;
}

export function isStaging() {
  return CURRENT_ENV === APP_ENV.Staging;
}

export function isTest() {
  return CURRENT_ENV === APP_ENV.Test;
}

export function isLocal() {
  return CURRENT_ENV === APP_ENV.Local;
}
